import React from 'react';
import DashboardLayout from '../components/DashboardLayout';
import LeadManager from '../components/LeadManager';

const AdminLeadsPage = () => (
  <DashboardLayout>
    <div data-testid="admin-leads-page">
      <LeadManager />
    </div>
  </DashboardLayout>
);

export default AdminLeadsPage;
